import {otmsHttp, bigDataHttp} from '@/utils/http/index.js'

/**
 * 查询补货货主数
 */
export function getReplenishmentCustomer(data) {
  return otmsHttp.post('/oms_plus/replenishment/customer/list', data)
}

/**
 * 查询货主补货列表
 */
export function getReplenishmentList(data) {
  return otmsHttp.post('/oms_plus/replenishment/list', data)
}

/**
 * 货品详情
  */
export function getReplenishmentDetail(data) {
  return bigDataHttp.post('/api/web/OMS/goodsDetail', data)
}

/**
 * 补货记录
  */
 export function getReplenishmentRecord(data) {
  return bigDataHttp.post('/api/web/OMS/replenishmentRecord', data)
}

/**
 * 补货上架条数
  */
 export function getReplenishmentCount(data) {
  return bigDataHttp.post('/api/web/OMS/replenishmentCount', data)
}